import { useCallback, useSyncExternalStore } from 'react';
import { Dimensions } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether the window is at least `minWidth` wide. The snapshot is a boolean, so a resize
 * only re-renders when it crosses the threshold, not on every width change.
 */
export const useWindowWidthAtLeast = (params: Params) => {
  const { minWidth } = params;

  const getSnapshot = useCallback(() => Dimensions.get('window').width >= minWidth, [minWidth]);

  return useSyncExternalStore(subscribeToWindowChanges, getSnapshot, getSnapshot);
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function subscribeToWindowChanges(onChange: () => void) {
  const subscription = Dimensions.addEventListener('change', onChange);

  return () => {
    subscription.remove();
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  minWidth: number;
};
